import React from "react";
import { Dimensions } from "react-native";
import LottieView from "lottie-react-native";
import { Box } from "app/components/common";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";

const { width } = Dimensions.get("window");

const LOTTIE_WIDTH = width > 900 ? width / 3 : width - 50;

export default class LottieAchieve extends React.Component {
  componentDidMount() {
    this?.animation?.play();
  }

  render() {
    return (
      <Box
        width={{ phone: LOTTIE_WIDTH, smallWeb: 145, web: LOTTIE_WIDTH }}
        height={isWeb ? "auto" : LOTTIE_WIDTH / 1.7}
        zIndex={-1}
        alignItems="center"
        justifyContent="center"
      >
        <LottieView
          ref={animation => {
            this.animation = animation;
          }}
          loop={false}
          source={require("../../../assets/lottie/achieve.json")}
        />
      </Box>
    );
  }
}
